import request from '../../utils/request';

// 客户管理--审批列表
export function approveList(param, Authorization,isloading){
  return request({
    url: '/api/qywechat/approval/bind',
    method: 'post',
    data: param,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 客户管理--审批详情
export function approveDetai(params, Authorization,isloading){
  return request({
    url: 'api/qywechat/approval/bind/detail',
    params,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 客户管理--所有档案详情
export function allFileDetai(param, Authorization,isloading){
  return request({
    url: '/api/qywechat/customer/detail/'+param,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 档案操作日志
export function fileOpLog(param, Authorization){
  return request({
    url: '/api/qywechat/bind/log',
    method: 'post',
    data: param,
    headers: {
      "authorization": Authorization,
      "Content-Type":"application/json"
    }
  })
}
// 档案操作日志详情
export function fileOpLogDetail(params, Authorization,isloading){
  return request({
    url: '/api/qywechat/bind/log/detail',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization,
    }
  },isloading)
}